export default function urlcWithPath(url: string): string {
  return `${process.env.PUBLIC_URL}/${url}`;
}

export function urlcToProjects(url: string): string {
  return `${process.env.PUBLIC_URL}/infinity/${url}`;
}
